<template>
<td @click="$emit('config-updated',option)">
    <input type="radio" :id="'option-'+option.optid" :name="'config-'+option.groupid" :checked="checked" />
    <span class="config_id text-primary">{{option.config_id}}</span>
    {{option.description}}
    <span v-if="orderMeta.level <= 3"
        class="hidden-xs">
        <span class="part"> -
            {{option.part_id}}</span>
    </span>
    <div class="idetail" v-show="!hideDetails || expanded">
        <div v-html="option.option_exp"></div>
    </div>
</td>
</template>

<script>
import useProductConfig from '../composables/useProductConfig';
import useProductInfo from '../composables/useProductInfo';
import { ref, computed, onMounted } from '@vue/composition-api';

export default {
    name: 'optionRadio',
    props: {
        option: {
            optid: Number,
            product_id: Number,
            groupid: Number,
            config_id: String,
            option_exp: String,
            description: String
        },
        hideDetails: Boolean,
        retired: Number,
        expandedGroups: Array
    },
    setup: function (props,{emit}) {
        const { optionInConfig, groupConfigured } = useProductConfig();
        const { orderMeta } = useProductInfo();

        const config_id = ref('');

        onMounted(() => {
            if (
                !groupConfigured(props.option.groupid, props.option.product_id) && //Another option in group isn't selected
                !optionInConfig(props.option.optid, props.option.product_id) && //The option isn't already selected
                props.option.option_sort == 1
            ) {
                emit('config-updated', props.option);
            }
        });

        const checked = computed(() => {
            var selectedOption = optionInConfig(props.option.optid, props.option.product_id);
            return selectedOption;
        });

        const expanded = computed(() => {
            var groupid = props.option.groupid;
            var index = props.expandedGroups.findIndex(function (item) {
                return item.groupid == groupid;
            });
            return (index > -1) ? props.expandedGroups[index].state : false;
        });

        return { 
            optionInConfig,
            groupConfigured,
            config_id,
            checked,
            expanded,
            orderMeta
        }
    },
    emits: ['config-updated']
}
</script>
